import React from "react"

const IconCircleAccent = (props) => {
    return(
        <div className='position-absolute' style={{right: '-1rem'}}>{props.content}</div>
    )
}

export default IconCircleAccent;